import consumer from "./consumer"
$(function () {
    $('[data-channel-subscribe="room"]').each(function (index, element) {
        var $element = $(element)
        var $room_id = $element.data('room')

        consumer.subscriptions.create(
            {
                channel: "RoomChannel",
                room: $room_id
            },
            {
                connected() {
                },

                received: function (data) {
                    const mine = $('#messages').data('user') == data.user_id;
                    const bubble = document.createElement('p');
                    bubble.className = mine ? 'from-me' : 'from-them';
                    String(data.content || '').split(/(https?:\/\/[^\s<>"']+)/).forEach(part => {
                        if (/^https?:\/\//.test(part)) {
                            const link = document.createElement('a');
                            link.href = part;
                            link.textContent = part;
                            link.target = '_blank';
                            link.rel = 'noopener noreferrer';
                            link.className = mine ? 'link-color-chat-me' : 'link-color-chat-them';
                            bubble.appendChild(link);
                        } else {
                            bubble.appendChild(document.createTextNode(part));
                        }
                    });
                    $('#messages').append(bubble);
                    const messages = $('#messages');
                    messages.scrollTop(messages.prop('scrollHeight'));
                }
            }
        );
    });
    $("#msg-field").val("");
});